export const ROLL_TOKEN_LIST_URL = "https://app.tryroll.com/tokens.json";
export const COINGECKO_TOKEN_LIST_URL = "https://tokens.coingecko.com/uniswap/all.json";
